import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import compose from '../hoc/compose';
import displayNames from './displayNames';
import Toggle from './toggle';
import Tooltip from './tooltip';
import _Symbol from './symbol';

var textFormattingToggleButton = function textFormattingToggleButton(props) {
  return /*#__PURE__*/React.createElement(Tooltip, {
    disabled: !props.tooltipContent,
    content: props.tooltipContent,
    shouldTranslate: props.shouldTranslate
  }, /*#__PURE__*/React.createElement(Toggle, {
    className: props.getClassName(_({
      'text-formatting-toggle-button': true,
      disabled: props.disabled,
      selected: props.value
    }).pickBy().keys().join(' ')),
    name: props.name,
    value: props.value,
    onChange: props.onChange,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(_Symbol, null, props.children)));
};

textFormattingToggleButton.displayName = displayNames.TEXT_FORMATTING_TOGGLE_BUTTON;
textFormattingToggleButton.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  tooltipContent: PropTypes.string
};
textFormattingToggleButton.defaultProps = {
  disabled: false
};
export default compose(textFormattingToggleButton);